module.exports = __webpack_public_path__ + "static/media/Twitter01.dc5eff98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Twitter01.svg
// module id = 332
// module chunks = 0